import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export function subscribeToConversationReadState(conversationId, userId, onError, onReadError) {
  const conversationRef = doc(db, 'conversations', conversationId);
  let active = true;
  let pending = false;
  let failed = false;
  const unsubscribe = onSnapshot(conversationRef, (snapshot) => {
    const unread = Number(snapshot.data()?.unreadCountByUser?.[userId] || 0);
    if (!active || unread <= 0 || pending || failed) return;
    // Rejected writes roll back the snapshot; do not retry from that rollback.
    pending = true;
    updateDoc(conversationRef, { [`unreadCountByUser.${userId}`]: 0 })
      .catch((error) => {
        failed = true;
        if (active) onReadError(error);
      })
      .finally(() => { pending = false; });
  }, onError);
  return () => { active = false; unsubscribe(); };
}
